<template>
  <section
    v-if="Object.keys(pricing).length"
    id="pricing-plan"
  >
    <!-- title text and switch button -->
    <div class="text-center mb-lg-5">
      <h1 class="mt-5">
        Planos e Preços
      </h1>
      <!--      <p class="mb-2 pb-75">-->
      <!--        All plans include 40+ advanced tools and features to boost your product. Choose the best plan to fit your needs.-->
      <!--      </p>-->
      <!--      <div class="d-flex align-items-center justify-content-center mb-5 pb-50">-->
      <!--        <h6 class="mr-1 mb-0">-->
      <!--          Monthly-->
      <!--        </h6>-->
      <!--        <b-form-checkbox-->
      <!--          id="priceSwitch"-->
      <!--          v-model="status"-->
      <!--          name="price-switch"-->
      <!--          value="annually"-->
      <!--          unchecked-value="monthly"-->
      <!--          switch-->
      <!--          @input="tooglePlan"-->
      <!--        />-->
      <!--        <h6 class="ml-50 mb-0">-->
      <!--          Annually-->
      <!--        </h6>-->
      <!--      </div>-->
    </div>
    <!--/ title text and switch button -->

    <!-- pricing plan cards -->
    <b-row class="pricing-card">
      <b-col
        offset-sm-2
        sm="10"
        md="12"
        offset-lg="2"
        lg="10"
        class="mx-auto"
      >
        <b-row>
          <b-col md="4">
            <b-card
              align="center"
            >

              <!--/ img -->
              <h3>{{ pricing.basicPlan.title }}</h3>
              <b-card-text>
                {{ pricing.basicPlan.subtitle }}
              </b-card-text>

              <!-- annual plan -->
              <div class="annual-plan">
                <div class="plan-price mt-2">
                  <sup class="font-medium-1 font-weight-bold text-primary">$</sup>
                  <span class="pricing-basic-value font-weight-bolder text-primary">{{ monthlyPlanShow ? pricing.basicPlan.monthlyPrice:pricing.basicPlan.yearlyPlan.perMonth }}</span>
                  <sub class="pricing-duration text-body font-medium-1 font-weight-bold">/mês</sub>
                </div>
                <small
                  v-show="!monthlyPlanShow"
                  class="annual-pricing text-muted"
                >USD {{ pricing.basicPlan.yearlyPlan.totalAnual }} / year</small>
              </div>
              <!--/ annual plan -->

              <!-- plan benefit -->
              <b-list-group class="list-group-circle text-left">
                <b-list-group-item
                  v-for="(data,index) in pricing.basicPlan.planBenefits"
                  :key="index"
                >
                  {{ data }}
                </b-list-group-item>
              </b-list-group>
              <!--/ plan benefit -->

              <!-- buttons -->
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                block
                class="mt-2"
                variant="success"
                disabled
              >
                Seu plano atual
              </b-button>
            </b-card>
          </b-col>
          <b-col md="4">
            <b-card
              class="popular"
              align="center"
            >
              <div
                v-show="pricing.standardPlan.popular"
                class="pricing-badge text-right"
              >
                <b-badge
                  variant="light-primary"
                  pill
                >
                  Popular
                </b-badge>
              </div>
              <!-- img -->

              <!--/ img -->
              <h3>{{ pricing.standardPlan.title }}</h3>
              <b-card-text>{{ pricing.standardPlan.subtitle }}</b-card-text>

              <!-- annual plan -->
              <div class="annual-plan">
                <div class="plan-price mt-2">
                  <sup class="font-medium-1 font-weight-bold text-primary">$</sup>
                  <span class="pricing-basic-value font-weight-bolder text-primary">{{ monthlyPlanShow ? pricing.standardPlan.monthlyPrice:pricing.standardPlan.yearlyPlan.perMonth }}</span>
                  <sub class="pricing-duration text-body font-medium-1 font-weight-bold">/mês</sub>
                </div>
                <small
                  v-show="!monthlyPlanShow"
                  class="annual-pricing text-muted"
                >USD {{ pricing.standardPlan.yearlyPlan.totalAnual }} / year</small>
              </div>
              <!--/ annual plan -->

              <!-- plan benefit -->
              <b-list-group class="list-group-circle text-left">
                <b-list-group-item
                  v-for="(data,index) in pricing.standardPlan.planBenefits"
                  :key="index"
                >
                  {{ data }}
                </b-list-group-item>
              </b-list-group>
              <!--/ plan benefit -->

              <!-- buttons -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                block
                class="mt-2"
                variant="primary"
                @click="apiPlano(plano)"
                :disabled="valorRetornado === 2"
              >
                Teste Grátis de 30 dias
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!--/ pricing plan cards -->

    <!-- pricing free trial -->
    <div class="pricing-free-trial">
      <b-row>
        <b-col
          lg="10"
          offset-lg="3"
          class="mx-auto"
        >
          <div class="pricing-trial-content d-flex justify-content-between">
            <div class="text-center text-md-left mt-3">
              <h3 class="text-primary">
                Ainda não está convencido? Comece com uma avaliação GRATUITA de 30 dias!
              </h3>
              <h5>Você terá acesso total a todos os recursos por 30 dias.</h5>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-2 mt-lg-3"
                @click="apiPlano(plano)"
                :disabled="valorRetornado === 2"
              >
                Comece a avaliação GRATUITA de 30 dias
              </b-button>
            </div>

          </div>
        </b-col>
      </b-row>
    </div>
    <!--/ pricing free trial -->
  </section>
</template>

<script>
import {
  BFormCheckbox, BRow, BCol, BCard, BImg, BCardText, BListGroup, BListGroupItem, BButton, BBadge,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import Ripple from 'vue-ripple-directive'
import PlanoService from '@/services/PlanoUpgrade'
/* eslint-disable global-require */
export default {
  components: {
    BFormCheckbox,
    BButton,
    BCardText,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BCard,
    BBadge,
    BImg,
    AppCollapseItem,
    AppCollapse,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      valorRetornado: '',
      status: 'monthly',
      monthlyPlanShow: true,
      pricing: {},
      dadosPagamento: [],
      plano: '',
    }
  },
  mounted() {
    this.buscarDados()
  },

  methods: {
    tooglePlan() {
      if (this.status === 'monthly') {
        this.monthlyPlanShow = true
      } else {
        this.monthlyPlanShow = false
      }
    },
    buscarDados() {
      const options = { method: 'GET' }

      fetch(`${this.VUE_APP_HOST_API_BACKEND}/pagamento/${this.userData.id}`, options)
        .then(response => response.json())
        .then(response => {
          this.configData(response[0])
          this.valorRetornado = response.length
        })
        .catch(err => console.error(err))
    },
    configData(response) {
      const planBenefitsChatBosster = [
        'Integração com o RD Station',
        'Integração com o Pipedrive',
        'Integração com o Active Campaign',
      ]
      const planBenefitsVSLBosster = [
        'Todos os recursos',
        '15.000 plays',
        'R$ 0,02 Por Play Extra',
      ]
      const monthlyPriceChatBosster = 86
      const monthlyPriceVSLBosster = 72
      const planoAtual = response.planocontratado
      const planoUpgrade = planoAtual === 'VSL Booster' ? 'CHAT Booster' : 'VSL Booster'
      this.plano = planoUpgrade

      const planAtualBenefits = planoUpgrade === 'CHAT Booster' ? planBenefitsVSLBosster : planBenefitsChatBosster
      const planUpgradeBenefits = planoUpgrade === 'CHAT Booster' ? planBenefitsChatBosster : planBenefitsVSLBosster
      const monthlyPricePlanAtual = planoUpgrade === 'CHAT Booster' ? monthlyPriceVSLBosster : monthlyPriceChatBosster
      const monthlyPriceUpgrade = planoUpgrade === 'CHAT Booster' ? monthlyPriceChatBosster : monthlyPriceVSLBosster

      const data = {
        pricing: {
          basicPlan: {
            title: `${planoAtual}`,
            subtitle: `Use O ${planoAtual} 30 dias grátis`,
            monthlyPrice: monthlyPricePlanAtual,
            yearlyPlan: {
              perMonth: 0,
              totalAnual: 0,
            },
            planBenefits: planAtualBenefits,
            popular: false,
          },
          standardPlan: {
            title: `${planoUpgrade}`,
            subtitle: 'Experimente por 30 dias grátis',
            monthlyPrice: monthlyPriceUpgrade,
            yearlyPlan: {
              perMonth: 40,
              totalAnual: 480,
            },
            planBenefits: planUpgradeBenefits,
            popular: true,
          },
        },
      }
      this.pricing = data.pricing
      console.log(this.pricing)
    },
    async apiPlano(plano) {
      const planoService = new PlanoService()
      await planoService.createUpgradePlano(this.userData.id, plano)
        .then(() => {
          this.$swal({
            title: 'Plano atualizado!',
            text: 'Seu plano foi atualizado com sucesso aproveite os benefícios do novo plano!',
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          }).then(() => {
            this.buscarDados()
          })
        })
        .catch(() => {
          this.$swal({
            title: 'Oops...',
            text: 'Algo deu errado!',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        })
    },

  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
